import React from 'react';
import AssignmentSearchParams from './AssignmentSearchParams';
import AssignmentService from '../../../Services/AssignmentService';
import EvaluatorAssignmentItem from '../../../Domain/EvaluatorAssignmentItem';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';

export default class EvaluatorAssignmentAdmin extends React.Component {
  static defaultProps = {
    evaluatorId: null,
  };

  constructor(props) {
    super(props);

    const searchItem = new AssignmentSearchParams();
    searchItem.EvaluatorId = this.props.evaluatorId;
    searchItem.IsEvaluatorRelatedSearch = true;

    this.state = {
      searchItem,
      cleared: false,
    };

    this.startSearch = this.startSearch.bind(this);
  }

  startSearch(searchItem) {
    const searchItemCopy = { ...searchItem, EvaluatorId: this.props.evaluatorId, IsEvaluatorRelatedSearch: true };

    this.setState({
      searchItem: searchItemCopy,
      cleared: false,
    });
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={EvaluatorAssignmentItem}
          serviceFunction={AssignmentService.GetEvaluatorAssignmentList}
          convertDBItemsFunction={AssignmentService.ConvertDBItemListEvaluator}
          showSearchStrip={false}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          errorCode='EAA56'
        />
      </div>
    );
  }
}
